import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static targets = ["eligibilityUserName", "eligibilityBallotCode", "eligibilityDateOfBirth", "eligibilityOverallStatus", "eligibilityDetailsTable"]
  static values = { electionId: Number }

  connect() {
    const eligibilityDetailsModalElement = document.getElementById('eligibilityDetailsModal')
    this.eligibilityDetailsModal = new Modal(eligibilityDetailsModalElement)
  }

  async showEligibilityDetails(event) {
    event.preventDefault()
    const ballotId = event.currentTarget.dataset.ballotId
    const userName = event.currentTarget.dataset.userName
    const ballotCode = event.currentTarget.dataset.ballotCode
    const electionId = event.currentTarget.dataset.electionId || this.electionIdValue

    // Set user info in modal
    this.eligibilityUserNameTarget.textContent = userName
    this.eligibilityBallotCodeTarget.textContent = ballotCode
    this.eligibilityDateOfBirthTarget.textContent = 'Loading...'

    // Show loading state
    this.eligibilityOverallStatusTarget.innerHTML = '<div class="text-center"><span class="spinner-border spinner-border-sm me-2"></span>Loading eligibility details...</div>'
    this.eligibilityDetailsTableTarget.innerHTML = '<tr><td colspan="4" class="text-center">Loading...</td></tr>'

    // Show modal
    this.eligibilityDetailsModal.show()

    try {
      const response = await fetch(`/admin/elections/${electionId}/election_ballots/${ballotId}/eligibility_details.json`)

      if (!response.ok) {
        throw new Error('Failed to fetch eligibility details')
      }

      const data = await response.json()

      // Display date of birth
      this.eligibilityDateOfBirthTarget.textContent = data.date_of_birth || 'Not Available'

      // Update overall status
      const statusBadge = data.is_eligible
        ? '<span class="badge bg-success fs-6">Eligible to Vote</span>'
        : '<span class="badge bg-danger fs-6">Not Eligible to Vote</span>'

      this.eligibilityOverallStatusTarget.innerHTML = `
        <div class="text-center">
          <h6 class="mb-2">Overall Eligibility Status</h6>
          ${statusBadge}
        </div>
      `

      // Update table with details
      let tableHTML = ''
      data.details.forEach(detail => {
        const resultBadge = detail.result === 'Passed'
          ? '<span class="badge bg-success">Passed</span>'
          : '<span class="badge bg-danger">Failed</span>'

        const rowClass = detail.critical ? 'table-warning' : ''

        tableHTML += `
          <tr class="${rowClass}">
            <td><strong>${detail.criterion}</strong></td>
            <td>${resultBadge}</td>
            <td><code>${detail.value}</code></td>
            <td>${detail.description}</td>
          </tr>
        `
      })

      this.eligibilityDetailsTableTarget.innerHTML = tableHTML

    } catch (error) {
      console.error('Error fetching eligibility details:', error)
      this.eligibilityOverallStatusTarget.innerHTML = '<div class="alert alert-danger">Error loading eligibility details</div>'
      this.eligibilityDetailsTableTarget.innerHTML = '<tr><td colspan="4" class="text-center text-danger">Error loading data</td></tr>'
    }
  }
}